import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=497ded0d&scoped=true"
import script from "./Scan.vue?vue&type=script&lang=js"
export * from "./Scan.vue?vue&type=script&lang=js"
import style0 from "./Scan.vue?vue&type=style&index=0&id=497ded0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ded0d",
  null
  
)

export default component.exports